type DataTableSkeletonProps = {
  className?: string;
  columns?: number | string[];
  rows?: number;
  showHeader?: boolean;
  rowHeight?: number;
};

const getColumnWidths = (columns: number | string[]): string[] => {
  if (Array.isArray(columns)) return columns;
  return Array.from({ length: columns }, (_, index) => {
    if (columns <= 2) return "100%";
    if (index === 0) return "24%";
    if (index === columns - 1) return "16%";
    return "18%";
  });
};

const DataTableSkeleton = ({
  className = "",
  columns = 5,
  rows = 6,
  showHeader = true,
  rowHeight = 48,
}: DataTableSkeletonProps) => {
  const headerSkeletonHeight = Math.max(12, Math.round(rowHeight * 0.3));
  const cellSkeletonHeight = Math.max(10, Math.round(rowHeight * 0.22));
  const resolvedColumns = getColumnWidths(columns);

  return (
    <div className={`w-100 ${className}`.trim()}>
      <div className="apple-card gestalt-group group border-0 shadow-sm rounded-5 p-4 skeleton-card">
        <div className="table-responsive">
          <table className="table align-middle mb-0">
            {showHeader && (
              <thead>
                <tr>
                  {resolvedColumns.map((width, index) => (
                    <th key={`header-${index}`} className="border-0 py-3">
                      <div
                        className={`skeleton-wave-block skeleton-light`}
                        style={{
                          height: headerSkeletonHeight,
                          width: typeof width === "string" ? width : "100%",
                          borderRadius: 8,
                        }}
                      />
                    </th>
                  ))}
                </tr>
              </thead>
            )}

            <tbody>
              {Array.from({ length: rows }).map((_, rowIndex) => (
                <tr key={`row-${rowIndex}`}>
                  {resolvedColumns.map((width, colIndex) => (
                    <td key={`cell-${rowIndex}-${colIndex}`} className="py-3 border-0">
                      <div
                        className={`skeleton-wave-block ${colIndex === 0 ? "skeleton-dark" : "skeleton-light"}`}
                        style={{
                          height: cellSkeletonHeight,
                          width: typeof width === "string" ? width : "100%",
                          minWidth: colIndex === 0 ? 120 : 70,
                          borderRadius: 8,
                        }}
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DataTableSkeleton;
